/**
 * Script para manejar enlaces ofuscados
 * Convierte elementos <span> o <div> con data-href en enlaces funcionales
 */
(function () {
  "use strict";

  const cartTriggerElements = new Set();
  let miniCartObserverInitialized = false;

  function setCartTriggersState(isOpen) {
    const value = isOpen ? "true" : "false";
    cartTriggerElements.forEach(function (trigger) {
      trigger.setAttribute("aria-expanded", value);
      trigger.dataset.ariaExpanded = value;
    });
  }

  function observeMiniCart() {
    if (miniCartObserverInitialized) {
      return;
    }

    const miniCart = document.getElementById("mini-cart");
    if (!miniCart) {
      return;
    }

    const syncState = function () {
      setCartTriggersState(miniCart.classList.contains("drawer--open"));
    };

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          syncState();
        }
      });
    });

    observer.observe(miniCart, {
      attributes: true,
      attributeFilter: ["class"],
    });

    syncState();
    miniCartObserverInitialized = true;
  }

  function registerCartTrigger(element) {
    if (!element || cartTriggerElements.has(element)) {
      return;
    }
    cartTriggerElements.add(element);
    observeMiniCart();
    const miniCart = document.getElementById("mini-cart");
    if (miniCart) {
      setCartTriggersState(miniCart.classList.contains("drawer--open"));
    }
  }

  function toggleMiniCart(element, href) {
    const miniCart = document.getElementById("mini-cart");
    if (!miniCart) {
      window.location.href = href;
      return true;
    }

    const hasOpenProperty =
      Object.prototype.hasOwnProperty.call(miniCart.__proto__, "open") ||
      typeof miniCart.open !== "undefined";
    const isOpen =
      miniCart.hasAttribute("open") ||
      miniCart.classList.contains("drawer--open");
    const bodyClassList = document.body && document.body.classList;

    if (isOpen) {
      if (hasOpenProperty) {
        miniCart.open = false;
      } else {
        const closeButton = miniCart.querySelector('[data-action="close"]');
        if (closeButton && typeof closeButton.click === "function") {
          closeButton.click();
        } else {
          miniCart.classList.remove("drawer--open");
          if (bodyClassList) {
            bodyClassList.remove("drawer-lock");
          }
        }
      }
      setCartTriggersState(false);
      return true;
    }

    if (hasOpenProperty) {
      miniCart.open = true;
    } else {
      const fallbackToggleLink = document.querySelector(
        '[is="toggle-link"][aria-controls="mini-cart"]'
      );
      if (
        fallbackToggleLink &&
        typeof fallbackToggleLink.click === "function"
      ) {
        fallbackToggleLink.click();
      } else {
        miniCart.classList.add("drawer--open");
        if (bodyClassList) {
          bodyClassList.add("drawer-lock");
        }
      }
    }

    setCartTriggersState(true);
    return true;
  }

  function handleObfuscatedLinks() {
    // Seleccionar todos los elementos con la clase obfuscated-link
    const obfuscatedLinks = document.querySelectorAll(
      ".obfuscated-link[data-href]"
    );

    obfuscatedLinks.forEach(function (element) {
      // Evitar agregar múltiples event listeners
      if (element.dataset.listenerAdded === "true") {
        return;
      }

      element.dataset.listenerAdded = "true";

      const activateLink = function (e) {
        e.preventDefault();
        e.stopPropagation();

        const href = element.getAttribute("data-href");

        if (!href) {
          return;
        }

        // Verificar si es un enlace de carrito que debe abrir el mini-cart
        // NOTA: Los enlaces de carrito deben usar <a is="toggle-link">, no obfuscated-link
        // Este código es solo para casos especiales donde se use obfuscated-link con cart
        const cartControls =
          element.getAttribute("aria-controls") ||
          element.getAttribute("data-aria-controls");
        const isCartLink =
          (element.hasAttribute("data-toggle-link") ||
            cartControls === "mini-cart") &&
          href &&
          href.includes("/cart");

        if (isCartLink) {
          registerCartTrigger(element);
          if (toggleMiniCart(element, href)) {
            return;
          }
        }

        // Verificar si es un componente personalizado de wishlist
        const isWishlist =
          element.hasAttribute("data-is") &&
          element.getAttribute("data-is") === "header-wishlist";

        if (isWishlist) {
          // Si hay un componente personalizado, intentar usarlo
          const wishlistComponent =
            element.closest('[is="header-wishlist"]') ||
            document.querySelector('[is="header-wishlist"]');
          if (
            wishlistComponent &&
            typeof wishlistComponent.click === "function"
          ) {
            // Dejar que el componente maneje el clic
            return;
          }
        }

        // Redirigir a la URL
        window.location.href = href;
      };

      // Manejar clic
      element.addEventListener("click", activateLink);
      element.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          activateLink(event);
        }
      });

      // Agregar estilo de cursor pointer si no está presente
      if (!element.style.cursor) {
        element.style.cursor = "pointer";
      }
    });
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", handleObfuscatedLinks);
  } else {
    handleObfuscatedLinks();
  }

  // También ejecutar después de que se cargue completamente la página
  // para capturar elementos cargados dinámicamente
  window.addEventListener("load", function () {
    handleObfuscatedLinks();
  });

  // Observar cambios en el DOM para elementos cargados dinámicamente
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      let shouldCheck = false;
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length > 0) {
          shouldCheck = true;
        }
      });
      if (shouldCheck) {
        handleObfuscatedLinks();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
